import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import { IGNORED_ERRORS, getSentryEnvironment } from './sentryFilters';

export const initSentry = () => {
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      sendDefaultPii: true,
      integrations: [new BrowserTracing()],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['https://cliente.contlabs.com.br'],
      environment: getSentryEnvironment(window.location.hostname, process.env.REACT_APP_ENV),
      ignoreErrors: IGNORED_ERRORS,
      _experiments: {
        enableLogs: true,
      },
    });
  }
};
